'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indexedDataInvariant = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = require('../../lib/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _IndexedAsyncData = require('../IndexedAsyncData');

var _IndexedAsyncData2 = _interopRequireDefault(_IndexedAsyncData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var indexedDataInvariant = exports.indexedDataInvariant = function indexedDataInvariant(indexedData) {
  return (0, _invariant2.default)(indexedData instanceof _IndexedAsyncData2.default, 'Expected indexedData to be a `IndexedAsyncData` not a `%s`', typeof indexedData === 'undefined' ? 'undefined' : _typeof(indexedData));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/indexed-async-data/invariants/indexedDataInvariant.js
// module id = 115
// module chunks = 2 3